<template>
  <div class="statistics-board" id="statistics-board">
    <div class="head">
      <div class="font-topic">{{ board.name || "加载中..." }}</div>
      <board-share-popper v-if="board.canShare" :board="board">
        <template v-slot:reference><base-button>分享</base-button></template>
      </board-share-popper>
    </div>
    <board-preview
      ref="board"
      hide-header
      manual-refresh
      @change="board = $event"
      @hook:mounted="boardMounted"
      :key="$route.params.boardId"
    ></board-preview>
  </div>
</template>

<script>
import BoardPreview from "@/views/Backend/Admin/Statistics/BoardPreview"
import BaseButton from "@/components/UIComponents/Button"
import BoardSharePopper from "@/components/BaseComponents/BoardSharePopper"

export default {
  name: "statistics-board",
  components: { BoardSharePopper, BaseButton, BoardPreview },
  data() {
    return {
      board: {}
    }
  },
  methods: {
    boardMounted() {
      this.$refs.board.refresh(this.$route.params.boardId)
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-board {
  height: 100%;
  background: #f5f7fa;
  .head {
    padding: 15px 18px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  ::v-deep {
    .board-preview {
      .wrapper {
        padding-top: 0;
      }
    }
  }
}
</style>
